/** Full-screen top-aligned on mobile; centered card from `md` up on web. */
export const MOBILE_FULLSCREEN_MODAL =
  "inset-0 top-0 overflow-y-auto px-4 pt-[calc(1rem+env(safe-area-inset-top,0px))] pb-[calc(1rem+env(safe-area-inset-bottom,0px))] pl-[calc(1rem+env(safe-area-inset-left,0px))] pr-[calc(1rem+env(safe-area-inset-right,0px))]"

export const DESKTOP_CENTERED_MODAL =
  "md:inset-auto md:left-[50%] md:top-[50%] md:translate-x-[-50%] md:translate-y-[-50%] md:max-w-lg md:p-6 md:rounded-lg md:overflow-visible data-[state=closed]:md:zoom-out-95 data-[state=open]:md:zoom-in-95 data-[state=closed]:md:slide-out-to-left-1/2 data-[state=closed]:md:slide-out-to-top-[48%] data-[state=open]:md:slide-in-from-left-1/2 data-[state=open]:md:slide-in-from-top-[48%]"

export const MOBILE_FULLSCREEN_MODAL_CLOSE =
  "absolute right-[calc(1rem+env(safe-area-inset-right,0px))] top-[calc(1rem+env(safe-area-inset-top,0px))]"

export const DESKTOP_CENTERED_MODAL_CLOSE = "md:right-4 md:top-4"

export function dialogContentLayoutClass() {
  return `${MOBILE_FULLSCREEN_MODAL} ${DESKTOP_CENTERED_MODAL}`
}

export function dialogCloseLayoutClass() {
  return `${MOBILE_FULLSCREEN_MODAL_CLOSE} ${DESKTOP_CENTERED_MODAL_CLOSE}`
}

export const MOBILE_ALERT_SHEET =
  "left-0 right-0 bottom-0 top-auto h-auto max-h-[calc(85dvh-env(safe-area-inset-top,0px))] rounded-t-2xl overflow-y-auto pt-6 pb-[calc(1.5rem+env(safe-area-inset-bottom,0px))] pl-[calc(1.5rem+env(safe-area-inset-left,0px))] pr-[calc(1.5rem+env(safe-area-inset-right,0px))]"

export const DESKTOP_CENTERED_ALERT = DESKTOP_CENTERED_MODAL.replace(/md:max-w-lg/g, "md:max-w-lg md:max-h-none")

export function alertDialogContentLayoutClass() {
  return `${MOBILE_ALERT_SHEET} ${DESKTOP_CENTERED_ALERT}`
}
